import React from 'react';
import Dialog from '../Dialog';
import DialogTitle from '../DialogTitle';
import DialogActions from '../DialogActions';
import DialogContent from '../DialogContent';
import DialogContentText from '../DialogContentText';
import Button from '../Button';
export const ConfirmationDialog = _ref => {
  let {
    rejectActions = [{
      reason: 'cancel',
      label: 'Cancel'
    }],
    resolveActions = [{
      reason: 'ok',
      label: 'OK'
    }],
    open = false,
    maxWidth = 900,
    onClose = () => {},
    onExited = () => {},
    onReject = () => {},
    onResolve = () => {},
    ...props
  } = _ref;
  const {
    title,
    description
  } = props;
  const handleReject = reason => {
    onClose();
    onReject(reason);
  };
  const handleResolve = reason => {
    onClose();
    onResolve(reason);
  };
  const handleExited = () => {
    onExited();
  };
  const hasRejectActions = Boolean(rejectActions) && rejectActions.length >= 1;
  const hasResolveActions = Boolean(resolveActions) && resolveActions.length >= 1;
  const handleClose = () => {
    if (hasRejectActions) {
      handleReject(undefined);
    } else {
      handleResolve(undefined);
    }
  };
  const renderActionButton = (index, action, isResolve) => {
    const handler = isResolve ? () => {
      handleResolve(action.reason);
    } : () => {
      handleReject(action.reason);
    };
    const autoFocus = isResolve && index === resolveActions.length - 1;
    return /*#__PURE__*/React.createElement(Button, {
      disabled: action.disabled == true ? true : false,
      color: action.color || "primary",
      key: action.label,
      variant: isResolve === true ? 'contained' : 'outlined',
      autoFocus: autoFocus,
      onClick: handler
    }, action.label);
  };
  return /*#__PURE__*/React.createElement(Dialog, {
    open: open,
    onClose: handleClose,
    TransitionProps: {
      onExited: handleExited
    },
    "aria-labelledby": "confirmtm-dialog-title",
    "aria-describedby": "confirmtm-dialog-description",
    PaperProps: {
      style: {
        minWidth: 300,
        maxWidth
      }
    }
  }, /*#__PURE__*/React.createElement(DialogTitle, {
    variant: "subtitle1",
    id: "confirmtm-dialog-title"
  }, title), Boolean(description) && /*#__PURE__*/React.createElement(DialogContent, null, /*#__PURE__*/React.createElement(DialogContentText, {
    id: "confirmtm-dialog-description"
  }, description)), /*#__PURE__*/React.createElement(DialogActions, null, hasRejectActions && rejectActions.map((action, index) => renderActionButton(index, action, false)), hasResolveActions && resolveActions.map((action, index) => renderActionButton(index, action, true))));
};
export default ConfirmationDialog;